var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SIZE_XL, SPACING_M, SPACING_XXL } from "../../helpers";
import { Text, TEXT_SIZE, TEXT_WEIGHT } from "../../Text";
var StyledText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n    line-height: ", ";\n    color: ", ";\n"], ["\n    height: ", ";\n    line-height: ", ";\n    color: ", ";\n"])), SIZE_XL, SIZE_XL, function (_a) {
    var theme = _a.theme;
    return theme.colorTextNavSecondary;
});
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    margin: 0;\n    padding-left: ", ";\n    padding-right: ", ";\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    margin: 0;\n    padding-left: ", ";\n    padding-right: ", ";\n"])), SPACING_M, SPACING_XXL);
export var NavigationMenuTitle = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(Wrapper, { "data-selector-id": rest['data-selector-id'] || 'navigation-title' },
        React.createElement(StyledText, { size: TEXT_SIZE.s, weight: TEXT_WEIGHT.semiBold, truncate: true }, children)));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=NavigationMenuTitle.js.map